import {
  HMStatusListForInterview,
  HMStatusListForScreen,
  HiringActivity,
} from './candidatePipeline.model';
import { IRejectionReasonDetails } from './candidateProfile.model';

export const hiringDecisionOption: IRejectionReasonDetails[] = [
  {
    rejectionReasonDescription: 'Advance to next step',
  },
  {
    rejectionReasonDescription: 'Do not advance to next step',
  },
];

export const shouldMakeDecision = (stage: HiringActivity) => {
  const decisionSteps = [
    HiringActivity.InInterview, // for interview-offer-reject
    HiringActivity.InScreen, // for screen-advance-reject
    HiringActivity.Submit,
    HiringActivity.Interview,
  ];
  return decisionSteps.includes(stage);
};

export enum HMDecisionModalActions {
  Pass = 'Pass',
  Shortlist = 'Shortlist',
  Offer = 'Offer',
  Advance = 'Advance',
}

export enum MakeDecisionStatus {
  HiringManagerAdvance = 'Hiring Manager Advance',
  HiringManagerOffer = 'Hiring Manager Offer',
  HiringManagerReject = 'Hiring Manager Reject',
}

export const HMDecisionTags = {
  Recommended: 'Recommended',
  NotRecommended: 'Not Recommended',
  OfferRecommended: 'Offer Recommended',
  OfferNotRecommended: 'Offer Not Recommended',
};

export type valueof<T> = T[keyof T];
export type THMDecisionModalActions = valueof<typeof HMDecisionModalActions>;
export type TMakeDecisionStatus = valueof<typeof MakeDecisionStatus>;
export type TMakeDecisionStages = valueof<typeof HiringActivity>;

export const getMakeDecisionStatus = (
  key: THMDecisionModalActions
): TMakeDecisionStatus => {
  switch (key) {
    case HMDecisionModalActions.Offer:
      return MakeDecisionStatus.HiringManagerOffer;
    case HMDecisionModalActions.Advance:
      return MakeDecisionStatus.HiringManagerAdvance;
    default:
      return MakeDecisionStatus.HiringManagerReject;
  }
};

export const getMakeDecisionStage = (
  key: THMDecisionModalActions
): TMakeDecisionStages => {
  switch (key) {
    case HMDecisionModalActions.Offer:
      return HiringActivity.ToBeEvaluated;
    case HMDecisionModalActions.Advance:
      return HiringActivity.ToBeEvaluated;
    default:
      return HiringActivity.InInterview;
  }
};

export const shouldAdvance = (stage: HiringActivity) => {
  const decisionSteps = [HiringActivity.InScreen];
  return decisionSteps.includes(stage);
};

export const getMakeDecisionButtonStatus = (
  stage: HiringActivity,
  currentActivityStatus: TMakeDecisionStatus
) => {
  if (!currentActivityStatus) {
    if (
      stage === HiringActivity.InInterview ||
      stage === HiringActivity.InScreen ||
      stage === HiringActivity.Interview ||
      stage === HiringActivity.Submit
    ) {
      return false;
    }
  } else {
    return true;
  }
};
